import { AiFillLinkedin, AiFillTwitterCircle, AiFillGithub, AiFillFacebook, AiFillInstagram } from 'react-icons/ai';

export const SOCIAL_ICONS = [
    {
        icon: <AiFillLinkedin size={23} />,
        href: "https://www.linkedin.com/in/mosabbir-ahamed/"
    },
    {
        icon: <AiFillInstagram size={23} />,
        href: "https://www.instagram.com/mosabbir_ahamed/"
    },
    {
        icon: <AiFillTwitterCircle size={23} />,
        href: "https://twitter.com/ahamed_mosabbir?t=Gi5ai4gBXTFcDjbkMiM_Mw&s=09"
    },
    {
        icon: <AiFillGithub size={23} />,
        href: "https://github.com/MosabbirAhamed/"
    },
    {
        icon: <AiFillFacebook size={23} />,
        href: "https://www.facebook.com/mosabbir.ahammed"
    },
]
